export default __webpack_public_path__ + "static/elemente-1@2x-9d575efe0e0b737993a0a5a7f87200ff.png";